import { ChevronDown, ChevronUp } from "lucide-react";
import { Input } from "./ui/input";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "./ui/collapsible";
import { Checkbox } from "../components/ui/checkbox";


export function CollapsibleOptions({ options, setOptions, isOpen, setIsOpen }) {

  return (
    <Collapsible className="w-full bg-slate-50 p-4 rounded-md" open={isOpen}>
      <CollapsibleTrigger className="flex items-center gap-2 text-sm font-medium" onClick={() => setIsOpen(!isOpen)}>

        Options {isOpen ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}

      </CollapsibleTrigger>
      <CollapsibleContent className="mt-4 space-y-4">
        <div className="grid gap-4">
          <div>
            <label className="text-sm font-medium mb-2 block">Page Options</label>
            <div className="grid gap-4 md:grid-cols-2">
              <Input
                className="bg-white"
                placeholder="Exclude Tags (e.g., script, .ad, #footer)"
                onChange={(e) => {
                  const tags = e.target.value.split(",").map((tag) => tag.trim()).filter(Boolean);
                  setOptions((prev) => ({ ...prev, excludeTags: tags }));
                }}
              />
              <Input
                className="bg-white"
                placeholder="Include Only Tags (e.g., script, .ad, #footer)"
                onChange={(e) => {
                  const tags = e.target.value.split(",").map((tag) => tag.trim()).filter(Boolean);
                  setOptions((prev) => ({ ...prev, includeTags: tags }));
                }}
              />
            </div>
          </div>
          <div className="grid gap-4 md:grid-cols-2">
            <div>
              <label className="text-sm font-medium mb-2 block">Wait for (in ms)</label>
              <Input
                className="bg-white"
                type="number"
                placeholder="1000"
                onChange={(e) => {
                  setOptions((prev) => ({ ...prev, delay: Number.parseInt(e.target.value) }));
                }}

              />
            </div>
            <div>
              <label className="text-sm font-medium mb-2 block">Pages to Crawl</label>
              <Input
                className="bg-white"
                type="number"
                placeholder="1"
                onChange={(e) => {
                  setOptions((prev) => ({ ...prev, pagesToCrawl: Number.parseInt(e.target.value) }));
                }}
              />
            </div>
          </div>
        </div>
        <div className="flex space-x-4 justify-between">
          <div className="flex gap-4">
            <div className="flex items-center space-x-2">
              <Checkbox
                id="mainContent"
                checked={options.mainContent}
                onCheckedChange={(checked) =>
                  setOptions((prev) => ({ ...prev, mainContent: !!checked }))
                }
              />
              <label htmlFor="mainContent" className="text-base">Main Content</label>
            </div>
            <div className="flex items-center space-x-2">
              <Checkbox
                id="htmlContent"
                checked={options.htmlContent}
                onCheckedChange={(checked) =>
                  setOptions((prev) => ({ ...prev, htmlContent: !!checked }))
                }
              />
              <label htmlFor="htmlContent" className="text-base">HTML Content</label>
            </div>
          </div>
          <div className="flex gap-4 items-center">
            <label className="text-sm font-medium mb-2 block">Depth</label>
            <Input
              className="bg-white"
              type="number"
              placeholder="1"
              onChange={(e) => {
                setOptions((prev) => ({ ...prev, depth: Number.parseInt(e.target.value) }));
              }}
            />
          </div>
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
}
